<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="collectFormValidator"
    >
      <v-card
        v-if="manifestId"
        flat
      >
        <v-toolbar flat>
          <v-toolbar-title>引渡し日の編集</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <!-- 回収日 -->
          <v-row>
            <v-col cols="12" md="6">
              <cs-date-picker
                :date.sync="forms.collected_date"
                :minimum-date="minimumDate"
                :maximum-date="maximumDate"
                @dateChangedCallback="dateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{
                        required: true,
                    }"
                    name="回収日"
                    class="requiredMark"
                  >
                    <v-text-field
                      v-model="forms.collected_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="回収日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            更新
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <send-mail-confirmable-dialog
      :manifest-id="manifestId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/manifest/managements/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: 'EditCollectDialog',
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    manifestId: {
      type: Number,
      default: () => null,
    },
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      basesCollectedDate: null,
      /** 予約登録日 */
      createdDate: null,
      forms: {
        collected_date: null,
      },
    }
  },
  computed: {
    minimumDate () {
      return this.$dayjs(this.createdDate).subtract(10, 'years').format("YYYY-MM-DD")
    },
    maximumDate () {
      return this.$dayjs(this.createdDate).add(5, 'years').format("YYYY-MM-DD")
    },

  },
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.collectFormValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverManifestManagementCollect', {
      fetchCollect: 'edit',
      updateCollect: 'update'
    }),
    ...mapActions("DriverManifestManagementVerifyCollect", {
      verifyCollect: "update",
    }),
    /**
     * 初期値を取得/設定
     */
    setVariable () {
      this.fetchCollect({ id: this.manifestId }).then((content) => {
        this.forms = content;
        this.basesCollectedDate = content.collected_date;
        this.createdDate = content.created_date;
      })
    },
    /**
     * 閉じるボタン クリックイベント
     * @description 呼び出し元で設定されたコールバックを呼び出します.
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.collectFormValidator.validateWithInfo().then(({ isValid, errors }) => {
        if(isValid) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyCollect({ id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateCollect({ id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      return {
        collected_date: this.forms.collected_date,
      }
    },
    dateChangedCallback (date) {
      this.forms.collected_date = date;
    },
  }

}
</script>

